import React from 'react';
import { Section } from './Section';
import { Gift, Target, Trophy, CalendarDays, Stethoscope, MessageCircle, CheckSquare } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: '100 Ejercicios de Saque: El Arma Secreta de tu Equipo',
  value: '$12.000',
  icon: Target
}, {
  num: 2,
  title: 'Kit Completo de Torneos Internos',
  value: '$10.000',
  icon: Trophy
}, {
  num: 3,
  title: 'Calendario del Entrenador: Tu Temporada Organizada',
  value: '$9.000',
  icon: CalendarDays
}, {
  num: 4,
  title: 'Primeros Auxilios en la Cancha: Guía Básica para el Profe',
  value: '$10.000',
  icon: Stethoscope
}, {
  num: 5,
  title: 'Comunicación que Inspira: Frases, Mensajes y Recursos',
  value: '$9.000',
  icon: MessageCircle
}, {
  num: 6,
  title: 'Checklist del Profe Organizado: Tu Rutina Semanal',
  value: '$8.000',
  icon: CheckSquare
}];
export function Bonuses() {
  return <Section darker className="border-t border-gold-500/10" data-id="element-19">
      <div className="text-center mb-8 md:mb-16" data-id="element-20">
        <div className="inline-flex items-center justify-center gap-2 bg-gold-500/10 text-gold-400 px-3 py-1.5 md:px-4 md:py-2 rounded-full font-semibold mb-4 md:mb-6 border border-gold-500/20 text-xs md:text-base" data-id="element-21">
          <Gift className="w-4 h-4 md:w-5 md:h-5" data-id="element-22" />
          <span data-id="element-23">Incluidos en todas las ofertas — sin costo extra</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-2 md:mb-4" data-id="element-24">
          Más los 6 Bonos Estratégicos
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 max-w-6xl mx-auto" data-id="element-25">
        {bonuses.map(bonus => <div key={bonus.num} className="bg-navy-800 rounded-xl md:rounded-2xl p-3 md:p-6 border border-navy-700 relative overflow-hidden group" data-id="element-26">
            <div className="absolute top-0 right-0 bg-red-500 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 md:px-3 md:py-1 rounded-bl-lg z-10" data-id="element-27">
              GRATIS
            </div>
            <div className="flex items-start gap-3 md:gap-4 relative z-10" data-id="element-28">
              <div className="bg-navy-900 p-2 md:p-3 rounded-lg md:rounded-xl border border-navy-700 group-hover:border-gold-500/50 transition-colors shrink-0" data-id="element-29">
                <bonus.icon className="w-5 h-5 md:w-6 md:h-6 text-gold-400" data-id="element-30" />
              </div>
              <div data-id="element-31">
                <div className="text-gold-500 text-[10px] md:text-sm font-bold mb-0.5 md:mb-1" data-id="element-32">
                  BONO {bonus.num}
                </div>
                <h3 className="text-white font-heading font-semibold leading-tight mb-1 md:mb-3 text-sm md:text-base" data-id="element-33">
                  {bonus.title}
                </h3>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-34">
                  <span className="text-gray-500 line-through" data-id="element-35">
                    Valor: {bonus.value}
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-36">→ GRATIS</span>
                </div>
              </div>
            </div>
          </div>)}
      </div>

      <div className="mt-6 md:mt-12 text-center bg-gradient-to-r from-navy-800 via-navy-700 to-navy-800 py-4 md:py-6 rounded-xl md:rounded-2xl border border-gold-500/30 max-w-3xl mx-auto" data-id="element-37">
        <p className="text-lg md:text-2xl font-heading font-bold text-white" data-id="element-38">
          Valor total de los 6 bonos:{' '}
          <span className="line-through text-gray-400" data-id="element-39">$58.000</span>{' '}
          <span className="text-gold-400" data-id="element-40">🎁 GRATIS</span>
        </p>
        <p className="text-gray-300 mt-1 md:mt-2 text-xs md:text-base" data-id="element-41">
          — Incluidos siempre —
        </p>
      </div>
    </Section>;
}